<template>
	<div class="checkbox c-field" :class="{'is-indeterminate': isIndeterminate}">
		<div class="c-checkbox-fancy">
			<div class="c-label c-editor">
				<label class="checkbox__label">
					<input
						v-model="internalValue"
						type="checkbox"
						:disabled="disabled"
						:aria-label="ariaLabel"
						@change="onChange"
						@click="onClick"
					/>
					<span class="checkbox__text">
						<span v-if="label">{{ label }}</span>
						<div v-if="$slots.default" class="checkbox__slot">
							<slot />
						</div>
					</span>
				</label>
			</div>
		</div>
		<div v-if="helptext" class="checkbox__helptext text-helptext">
			{{ helptext }}
		</div>
	</div>
</template>

<script>
	export default {
		model: {
			prop: 'value',
			event: 'input'
		},
		props: {
			label: {
				type: String,
				default: ''
			},
			value: {
				type: Boolean,
				default: false
			},
			disabled: {
				type: Boolean,
				default: false
			},
			isIndeterminate: {
				type: Boolean,
				default: false
			},
			ariaLabel: {
				type: String,
				default: null
			},
			helptext: {
				type: String,
				default: null
			}
		},
		data() {
			return {
				internalValue: this.value && !this.isIndeterminate
			};
		},
		watch: {
			internalValue(val) {
				this.$emit('input', val);
			},
			value: {
				immediate: true,
				handler(val) {
					this.internalValue = val && !this.isIndeterminate;
				}
			},
			isIndeterminate(val) {
				this.internalValue = !val; // Clicking on indeterminate checkbox should always enter checked state
			}
		},
		methods: {
			onChange() {
				this.$emit('change', this.internalValue);
			},
			onClick() {
				// Note: by the time the click event is being emitted, the internalValue has not yet been updated
				this.$emit('click', this.internalValue);
			}
		}
	};
</script>
<style lang="scss" src="@cognitoforms/styles/app/common/_checkables.scss"></style>

<style lang="scss" >
.checkbox {

	&.c-field {
		padding: 0;
	}

	&__text {

		& > * {
			display: block;
			margin-left: 3px;
		}
	}

	&__slot {
		margin-top: 3px;
	}

	&__helptext {
		margin-left: 24px;
	}

	&.is-indeterminate {

		.checkbox__text {

			&::before {
				background-color: var(--bg-selected-intense);
				border-color: var(--bg-selected-intense);
			}

			&::after {
				display: block;
				position: absolute;
				left: 3px;
				top: 50%;
				width: 10px;
				height: 2px;
				background-color: var(--shade-1);
				margin-top: -1px;
				content: '';
			}
		}
	}
}
</style>